import { GlassOrder, GlassOrderFormData, GetGlassOrdersParams } from "../interfaces/GlassOrder";
import { ApiResponse } from "../interfaces/Api";
import { Get, Patch, Post, Delete } from "./apiHelper";

const glassOrderRoot = "/api/glassOrders";

export const getGlassOrders = async (
  params?: GetGlassOrdersParams
): Promise<
  ApiResponse<{
    results: GlassOrder[];
    total: number;
  }>
> => {
  const query = new URLSearchParams();

  if (params?.from) {
    query.append("from", params.from instanceof Date ? params.from.toISOString() : params.from);
  }
  if (params?.until) {
    query.append("until", params.until instanceof Date ? params.until.toISOString() : params.until);
  }
  if (params?.clientIds && params.clientIds.length > 0) {
    query.append("clientIds", params.clientIds.join(","));
  }
  if (params?.status) {
    query.append("status", params.status);
  }
  if (params?.page !== undefined) {
    query.append("page", params.page.toString());
  }
  if (params?.pageSize !== undefined) {
    query.append("pageSize", params.pageSize.toString());
  }

  const queryString = query.toString();
  const url = `${glassOrderRoot}${queryString ? `?${queryString}` : ""}`;

  const response = await Get(url, true);
  return response.data as ApiResponse<{
    results: GlassOrder[];
    total: number;
  }>;
};

export const getGlassOrder = async (id: string | number): Promise<ApiResponse<GlassOrder>> => {
  const response = await Get(`${glassOrderRoot}/${id}`, true);
  return response.data as ApiResponse<GlassOrder>;
};

export const postGlassOrder = async (
  payload: Partial<GlassOrderFormData>
): Promise<ApiResponse<GlassOrder>> => {
  const response = await Post(glassOrderRoot, payload, true);
  return response.data as ApiResponse<GlassOrder>;
};

export const patchGlassOrder = async (
  id: string | number,
  payload: Partial<GlassOrderFormData>
): Promise<ApiResponse<GlassOrder>> => {
  const response = await Patch(`${glassOrderRoot}/${id}`, payload, true);
  return response.data as ApiResponse<GlassOrder>;
};

export const updateGlassOrderStatus = async (
  id: string | number,
  payload: { status?: string; deliveryDate?: string | null }
): Promise<ApiResponse<GlassOrder>> => {
  const response = await Patch(`${glassOrderRoot}/${id}/updateStatus`, payload, true);
  return response.data as ApiResponse<GlassOrder>;
};

export const deleteGlassOrder = async (id: string | number): Promise<ApiResponse<null>> => {
  const response = await Delete(`${glassOrderRoot}/${id}`, true);
  return response.data as ApiResponse<null>;
};
